import { motion, type Variants } from 'motion/react';
import { type FC, type ReactNode } from 'react';

interface AnimatedPageProps {
    children: ReactNode;
}

const pageVariants: Variants = {
    initial: {
        opacity: 0,
        x: -20,
    },
    animate: {
        opacity: 1,
        x: 0,
    },
    exit: {
        opacity: 0,
        x: 20,
    },
};

export const AnimatedPage: FC<AnimatedPageProps> = ({ children }) => (
    <motion.div
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        style={{ width: '100%', minHeight: '100%' }}
    >
        {children}
    </motion.div>
);
